module.exports = __webpack_public_path__ + "img/en.a78ab0ef.svg";